import { Skeleton } from "@/components/ui/skeleton"
import { ProductCardSkeleton } from "~/components/shared/product-card/skeleton"

const GRID_SKELETON_COUNT = 6
const LIST_SKELETON_COUNT = 3

interface CategoryProductsListSkeletonProps {
  view?: "grid" | "list"
}

export function CategoryProductsListSkeleton({
  view = "grid",
}: CategoryProductsListSkeletonProps): React.ReactNode {
  const skeletonCount =
    view === "grid" ? GRID_SKELETON_COUNT : LIST_SKELETON_COUNT

  return (
    <section className='space-y-4'>
      <header className='rounded-md border border-gray-200 bg-white p-4'>
        <Skeleton className='h-7 w-52' />
        <div className='mt-4 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between'>
          <Skeleton className='h-4 w-40' />
          <div className='flex flex-wrap items-center gap-2'>
            <Skeleton className='h-10 w-54' />
            <Skeleton className='h-10 w-24' />
          </div>
        </div>
      </header>

      <div
        className={
          view === "grid"
            ? "grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3"
            : "space-y-3"
        }
      >
        {Array.from({ length: skeletonCount }).map((_, index) => (
          <ProductCardSkeleton
            className='w-full'
            // biome-ignore lint/suspicious/noArrayIndexKey: Static placeholder list for Suspense fallback.
            key={`category-products-skeleton-${index}`}
          />
        ))}
      </div>
    </section>
  )
}
